import recruiterEn from 'i18n/recruiter_score_card.en.json'
import recruiterNb from 'i18n/recruiter_score_card.nb.json'
import { titleCase } from 'utils/stringFormat'

const SCORE_CARDS = { en: recruiterEn, nb: recruiterNb }

export const getRecruiterTraits = language =>
  (SCORE_CARDS[language] || SCORE_CARDS.en).traits || {}

const replaceTraitPlaceholders = (text, label) =>
  String(text ?? '')
    .replace(/\{ *trait *\}/g, label.toLowerCase())
    .replace(/\{ *Trait *\}/g, titleCase(label))

export const formatTraitAbstract = (abstract, label) =>
  replaceTraitPlaceholders(
    String(abstract ?? '').split(/\s*\n\s*/)[0],
    label,
  ).trim()
